import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "loansToRefinanceSection" }
const _hoisted_2 = { class: "loansToRefinanceTableWrapper" }
const _hoisted_3 = {
  key: 0,
  class: "add-loan-btn-wrapper"
}
const _hoisted_4 = { class: "add-loan-disclaimer" }
const _hoisted_5 = ["href"]
const _hoisted_6 = {
  key: 1,
  class: "loans-to-refinance-section-table-header"
}
const _hoisted_7 = { class: "header title" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = {
  key: 0,
  class: "header data"
}
const _hoisted_10 = { class: "loans-to-refinance-table" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  key: 1,
  class: "actions"
}
const _hoisted_13 = { class: "checkbox-container" }
const _hoisted_14 = ["value", "checked", "onChange"]
const _hoisted_15 = { colspan: "6" }
const _hoisted_16 = { class: "payoff-details-wrapper" }
const _hoisted_17 = { class: "footer" }
const _hoisted_18 = {
  class: "text-right",
  colspan: "6"
}
const _hoisted_19 = { class: "footer inverse" }
const _hoisted_20 = {
  class: "text-right",
  colspan: "6"
}
const _hoisted_21 = { class: "loans-to-refinance-table-footer row" }
const _hoisted_22 = {
  key: 0,
  class: "pagination"
}
const _hoisted_23 = ["disabled"]
const _hoisted_24 = { class: "pages-wrapper" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = ["disabled"]

import { ref, reactive } from "vue";
import { useStore } from "vuex";
import { computed } from "vue";
import useFormatter from "@/use/formatter";
import { ApplicationStatusTypeIds } from "@/config/constants";


export default /*@__PURE__*/_defineComponent({
  __name: 'LoansToRefinanceTable',
  props: {
  id: {
    type: String,
    default: "",
  },
  showActionsColumn: {
    type: Boolean,
    default: false,
  },
  showPayoffDetails: {
    type: Boolean,
    default: false,
  },
  showTableHeader: {
    type: Boolean,
    default: true,
  },
  showAddLoanButton: {
    type: Boolean,
    default: true,
  },
  showIncludedLoansOnly: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props;

const store = useStore();
const { formatMoney } = useFormatter();

const loading = ref<boolean>(true);
const addLoanClicked = ref<boolean>(false);

const applicationStatusId = computed(() => store.state.appData?.application?.applicationStatusId);

const emailAddress = computed(() => store.getters["contactUs"]?.email);
const refiLoans = computed(() => store?.getters["applicationInfoModule/RefiLoans"]);
const filteredRefiLoans = computed(
  () => store?.getters["applicationInfoModule/FilteredRefiLoans"] || [],
);

const canEdit = computed(
  () =>
    (applicationStatusId.value === ApplicationStatusTypeIds.SUBMITTED_AND_PROCESSING &&
      store.getters["consentsModule/SLR_PAYOFF_CONFIRMATION_EXISTS"] === false) ||
    (applicationStatusId.value !== ApplicationStatusTypeIds.RIGHT_TO_CANCEL &&
      applicationStatusId.value !== ApplicationStatusTypeIds.COMPLETE),
);

const loanDetailsModal = computed(() => store.state.applicationInfoModule.loanModal);

const refiLoansData = computed(() => {
  switch (props.id) {
    case "ApplicationInfoTile":
      return refiLoans.value;
    case "Parent_LoanDetailsModal":
      return loanDetailsModal.value.loans;
    case "Parent_ConfirmYourRefinanceDetailsModal":
      return loanDetailsModal.value.loans;
    default:
      return [];
  }
});

const tableFooterTotalText = computed(() => {
  switch (props.id) {
    case "ApplicationInfoTile":
      return "Estimated Total To Refinance";
    default:
      return "Total to Refinance";
  }
});

const totalDisplay = computed(() => {
  switch (props.id) {
    case "ApplicationInfoTile":
      return estimatedTotalToRefinanceDisplay.value;
    case "Parent_ConfirmYourRefinanceDetailsModal":
      return loanDetailsModal.value.totalToRefinanceDisplay;
    default:
      return calculatedEstimatedTotalToRefinanceDisplay.value;
  }
});

const calculatedEstimatedTotalToRefinance = computed<number>(() => {
  // only include the candidate refi loans that have include flag set to true
  // manually added candidate refi loans should be included by default since ui does not show a checkbox
  return refiLoansData.value?.reduce(function (acc: any, obj: any) {
    let bal =
      typeof obj.creditReportBalance === "string"
        ? parseFloat(obj.creditReportBalance)
        : obj.creditReportBalance;

    return obj.include ? acc + bal : acc;
  }, 0);
});
const calculatedEstimatedTotalToRefinanceDisplay = computed<number>(() => {
  return formatMoney(calculatedEstimatedTotalToRefinance.value, 0);
});
const estimatedTotalToRefinanceDisplay = computed(
  () => store?.state?.applicationInfoModule?.applicationInfo?.estimatedTotalDisplay,
);

const headers = computed(() => [
  { label: "Account Number* (if known)", field: "accountNumber", visible: true },
  { label: "Lender/Loan Servicer", field: "servicerName", visible: true },
  { label: "Estimated Current Balance", field: "creditReportBalanceDisplay", visible: true },
  { label: "Final Payoff Amount", field: "payoffAmountDisplay", visible: props.showPayoffDetails },
  { label: "Include?", field: "", visible: props.showActionsColumn },
]);

function openModal() {
  store.dispatch("applicationInfoModule/openModal", "LoanDetails");
}

function handleCheckboxEvent(refiLoan: any, event: any) {
  const updatedRefiLoan = Object.assign({}, refiLoan);
  updatedRefiLoan.include = event.target.checked;
  store.dispatch("applicationInfoModule/updateRefiLoan", updatedRefiLoan);
  store.dispatch(
    "applicationInfoModule/setCalculatedEstimatedTotalToRefinance",
    calculatedEstimatedTotalToRefinance.value,
  );
}

function handleAddLoanButtonClick() {
  addLoanClicked.value = true;
}

// PAGINATION
const paginationEnabled = computed<boolean>(() => refiLoansData.value?.length > 3);

const pagination = reactive({
  currentPage: 1,
  allowPagination: false,
  perPage: computed(() =>
    pagination.allowPagination || refiLoansData.value?.length <= 0
      ? 3
      : refiLoansData.value?.length,
  ),
  totalPages: computed(() => Math.ceil(refiLoansData.value?.length / pagination.perPage)),
  pages: [],
}) as any;

const pages = computed<Array<any>>((i: any) => {
  return [...Array(pagination.totalPages).keys()].map(i => i + 1);
});

const paginatedItems = computed(() => {
  const { currentPage, perPage } = pagination;

  if (!currentPage || !paginationEnabled.value) {
    return refiLoansData.value;
  } else {
    const start = (currentPage - 1) * perPage;
    const stop = start + perPage;
    return refiLoansData.value.slice(start, stop);
  }
});

const starting = computed<number>(() =>
  Math.ceil((pagination.currentPage - 1) * pagination.perPage),
);
const ending = computed<number>(() =>
  starting.value + 1 * pagination.perPage > refiLoansData.value.length
    ? refiLoansData.value.length
    : starting.value + 1 * pagination.perPage,
);
const paginatedItemsDisplayCounter = computed(() =>
  paginationEnabled.value
    ? `${starting.value + 1} - ${ending.value} `
    : `${starting.value + 1} - ${refiLoansData.value.length} `,
);
function previous() {
  if (pagination.currentPage > 1) {
    pagination.currentPage--;
    loading.value = true;
  }
}
function next() {
  if (pagination.currentPage < pagination.totalPages) {
    window.scrollTo(0, 0);
    pagination.currentPage++;
    loading.value = true;
  }
}
function changePage(newPage: string) {
  window.scrollTo(0, 0);
  pagination.currentPage = parseInt(newPage);
  loading.value = true;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (__props.showAddLoanButton)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("button", {
              class: "add-loan-btn add-btn",
              onClick: handleAddLoanButtonClick
            }, "Add Loan"),
            _withDirectives(_createElementVNode("p", _hoisted_4, [
              _cache[0] || (_cache[0] = _createTextVNode(" If you want to add another loan, we will need to verify additional information. Please reach out to the processing team for assistance at ", -1)),
              _createElementVNode("a", {
                class: "email-link",
                href: `mailto:${emailAddress.value}`
              }, _toDisplayString(emailAddress.value) + ".", 9, _hoisted_5)
            ], 512), [
              [_vShow, addLoanClicked.value]
            ])
          ]))
        : _createCommentVNode("", true),
      (__props.showTableHeader)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _cache[1] || (_cache[1] = _createElementVNode("span", null, "Loans to Refinance", -1)),
              (canEdit.value)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    class: "edit-link",
                    onClick: _withModifiers(openModal, ["prevent"]),
                    disabled: !canEdit.value
                  }, "Edit", 8, _hoisted_8))
                : _createCommentVNode("", true)
            ]),
            (refiLoansData.value?.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, " Showing items " + _toDisplayString(paginatedItemsDisplayCounter.value) + " of " + _toDisplayString(refiLoansData.value.length) + " items ", 1))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("table", _hoisted_10, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(headers.value.filter((h) => h.visible), (header) => {
              return (_openBlock(), _createElementBlock("th", {
                key: header.field
              }, _toDisplayString(header.label), 1))
            }), 128))
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedItems.value, (loan) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: loan.id
            }, [
              _createElementVNode("tr", null, [
                _createElementVNode("td", null, _toDisplayString(loan?.accountNumber), 1),
                _createElementVNode("td", null, _toDisplayString(loan?.servicerName), 1),
                _createElementVNode("td", null, _toDisplayString(loan?.creditReportBalanceDisplay), 1),
                (__props.showPayoffDetails)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_11, _toDisplayString(loan?.payoffAmountDisplay), 1))
                  : _createCommentVNode("", true),
                (__props.showActionsColumn)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_12, [
                      _createElementVNode("label", _hoisted_13, [
                        _createElementVNode("input", {
                          class: "form-check-input",
                          type: "checkbox",
                          value: loan.include,
                          checked: loan.include,
                          onChange: _withModifiers(($event: any) => (handleCheckboxEvent(loan, $event)), ["prevent"])
                        }, null, 40, _hoisted_14),
                        _cache[2] || (_cache[2] = _createElementVNode("span", { class: "checkmark" }, null, -1))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _withDirectives(_createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _cache[3] || (_cache[3] = _createElementVNode("div", null, [
                      _createElementVNode("i", null, "Payoff Details")
                    ], -1)),
                    _createElementVNode("div", null, _toDisplayString(loan?.payoffDetailDisplay), 1)
                  ])
                ])
              ], 512), [
                [_vShow, __props.showPayoffDetails && loan?.payoffDetailDisplay]
              ])
            ], 64))
          }), 128)),
          _createElementVNode("tr", _hoisted_17, [
            _createElementVNode("td", _hoisted_18, [
              _createElementVNode("span", null, _toDisplayString(tableFooterTotalText.value), 1)
            ])
          ]),
          _createElementVNode("tr", _hoisted_19, [
            _createElementVNode("td", _hoisted_20, _toDisplayString(totalDisplay.value), 1)
          ])
        ])
      ]),
      _cache[6] || (_cache[6] = _createElementVNode("span", null, "* = Optional if known", -1)),
      _createElementVNode("div", _hoisted_21, [
        (paginationEnabled.value && pages.value.length > 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
              _createElementVNode("button", {
                class: "pagination:number arrow",
                onClick: previous,
                disabled: pagination.currentPage === 1
              }, [...(_cache[4] || (_cache[4] = [
                _createElementVNode("span", null, "<", -1)
              ]))], 8, _hoisted_23),
              _createElementVNode("div", _hoisted_24, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pages.value, (page) => {
                  return (_openBlock(), _createElementBlock("button", {
                    class: _normalizeClass(["page", { current: page === pagination.currentPage }]),
                    key: page,
                    onClick: ($event: any) => (changePage(page))
                  }, _toDisplayString(page), 11, _hoisted_25))
                }), 128))
              ]),
              _createElementVNode("button", {
                class: "pagination:number arrow",
                onClick: next,
                disabled: pagination.currentPage === pages.value.length
              }, [...(_cache[5] || (_cache[5] = [
                _createElementVNode("span", null, ">", -1)
              ]))], 8, _hoisted_26)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})